import { createRequestOptions, logFetchError, logFetchFailure } from "../../utils/utils";
import { HttpMethodType } from "../models/HttpMethodType";
import { IApplicationState } from "../models/IApplicationState";
import { IApplicationVersion } from "../models/IApplicationVersion";
import { ISettings } from "../models/ISettings";

export const apiUrl: string = "/api/settings";

export const SET_ERROR_MESSAGE: string = "SET_ERROR_MESSAGE";
export const CLEAR_ERROR_MESSAGE: string = "CLEAR_ERROR_MESSAGE";
export const SET_SETTINGS_ISLOADING: string = "SET_SETTINGS_ISLOADING";
export const SET_SETTINGS: string = "SET_SETTINGS";
export const SET_VERSION_ISLOADING: string = "SET_VERSION_ISLOADING";
export const SET_VERSION: string = "SET_VERSION";

interface ISetErrorMessageActionType { type: string, errorMessage: string };
interface IClearErrorMessageActionType { type: string };
interface ISetSettingsIsLoadingActionType { type: string, isLoading: boolean };
interface ISetSettingsActionType { type: string, settings: ISettings };
interface ISetVersionIsLoadingActionType { type: string, isVersionLoading: boolean };
interface ISetVersionActionType { type: string, applicationVersion: IApplicationVersion };

export function setErrorMesssage(errorMessage: string): ISetErrorMessageActionType {
    return { type: SET_ERROR_MESSAGE, errorMessage: errorMessage };
}

export function clearErrorMesssage(): IClearErrorMessageActionType {
    return { type: CLEAR_ERROR_MESSAGE };
}

export function setSettingsIsLoading(isLoading: boolean): ISetSettingsIsLoadingActionType {
    return { type: SET_SETTINGS_ISLOADING, isLoading: isLoading };
}

export function setSettings(settings: ISettings): ISetSettingsActionType {
    return { type: SET_SETTINGS, settings: settings };
}

export function setVersionIsLoading(isVersionLoading: boolean): ISetVersionIsLoadingActionType {
    return { type: SET_VERSION_ISLOADING, isVersionLoading: isVersionLoading };
}

export function setVersion(applicationVersion: IApplicationVersion): ISetVersionActionType {
    return { type: SET_VERSION, applicationVersion: applicationVersion };
}

export function getApplicationVersion(): any {
    return (dispatch: any, getState: any) => {
        var state: IApplicationState = getState().applicationState;
        if (state && state.isVersionLoading) {
            // No need to load as already loading.
            return;
        }

        // Update that version will be loaded.
        dispatch({ type: SET_VERSION_ISLOADING, isVersionLoading: true });

        const requestInit = createRequestOptions();
        const errorMessage = "Failed to retrieve version.";
        const url = `${apiUrl}/version`;

        fetch(url, requestInit)
            .then(async (response) => {
                let responseBody = await response.json();

                if (response.ok) {
                    const applicationVersion = responseBody as IApplicationVersion;
                    dispatch({ type: SET_VERSION, applicationVersion: applicationVersion });
                }
                else {
                    logFetchFailure(url, response, responseBody);

                    // Update the application error.
                    dispatch({ type: SET_ERROR_MESSAGE, errorMessage: errorMessage });
                }
            })
            .catch((error: any) => {
                logFetchError(error);

                // Update the application error.
                dispatch({ type: SET_ERROR_MESSAGE, errorMessage: errorMessage });

                // Update that version is not loading.
                dispatch({ type: SET_VERSION_ISLOADING, isVersionLoading: false });
            });
    }
}

export function getSettings(): any {
    return (dispatch: any, getState: any) => {
        var state: IApplicationState = getState().applicationState;
        if (state && state.isLoading) {
            // No need to load as already loading.
            return;
        }

        // Update that settings will be loaded.
        dispatch({ type: SET_SETTINGS_ISLOADING, isLoading: true });

        const requestInit = createRequestOptions();
        const errorMessage = "Failed to retrieve settings.";

        fetch(apiUrl, requestInit)
            .then(async (response) => {
                let responseBody = await response.json();

                if (response.ok) {
                    const settings = responseBody as ISettings;
                    dispatch({ type: SET_SETTINGS, settings: settings });
                }
                else {
                    logFetchFailure(apiUrl, response, responseBody);

                    // Update the application error.
                    dispatch({ type: SET_ERROR_MESSAGE, errorMessage: errorMessage });
                }
            })
            .catch((error: any) => {
                logFetchError(error);

                // Update the application error.
                dispatch({ type: SET_ERROR_MESSAGE, errorMessage: errorMessage });

                // Update that items are not loading.
                dispatch({ type: SET_SETTINGS_ISLOADING, isLoading: false });
            });
    }
}

export function saveSettings(settings: ISettings): any {
    return (dispatch: any) => {
        const requestInit = createRequestOptions(HttpMethodType.Put, JSON.stringify(settings));
        const upsertUrl = `${apiUrl}`;
        const errorMessage = "Failed to save settings.";

        fetch(upsertUrl, requestInit)
            .then(async (response) => {
                let responseBody = await response.json();

                if (response.ok) {
                    const settings = responseBody as ISettings;
                    dispatch({ type: SET_SETTINGS, settings: settings });
                }
                else {
                    logFetchFailure(upsertUrl, response, responseBody);

                    // Update the application error.
                    dispatch({ type: SET_ERROR_MESSAGE, errorMessage: errorMessage });
                }
            })
            .catch((error: any) => {
                logFetchError(error);

                // Update the application error.
                dispatch({ type: SET_ERROR_MESSAGE, errorMessage: errorMessage });
            });
    }
}